import { render, staticRenderFns } from "./UserSelectMenu.vue?vue&type=template&id=15fa9848&scoped=true&"
import script from "./UserSelectMenu.vue?vue&type=script&lang=js&"
export * from "./UserSelectMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectMenu.vue?vue&type=style&index=0&id=15fa9848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa9848",
  null
  
)

export default component.exports